export const FilterDataType = {
  STRING: 'string',
  INT: 'int',
  DOUBLE: 'double',
  BOOLEAN: 'boolean',
  DATE: 'date',
  DATE_RANGE: 'date-range',
  ARRAY_STRING: 'array-string',
  ARRAY_INT: 'array-int',
}

export const FilterOperators = {
  Equal: { code: '==', text: '=' },
  NotEqual: { code: '!=', text: '≠' },
  In: { code: 'IN', text: 'IN' },
  NotIn: { code: 'NIN', text: 'NOT IN' },
  Like: { code: 'LIKE', text: 'LIKE' },
  Between: { code: 'BETWEEN', text: 'BETWEEN' },
  NotBetween: { code: 'NOTBETWEEN', text: 'NOT BETWEEN' },

  // todo
  LessThen: { code: '<', text: '<' },
  LessThenOrEqual: { code: '<=', text: '≤' },
  GreaterThen: { code: '>', text: '>' },
  GreateThenOrEqual: { code: '>=', text: '≥' },
}
